<template>
  <div style="position: relative;">
    <iframe
      src="/horizon"
      frameborder="0"
      style="position: absolute; left: 0; top: 0; width: 100%; height: 100%;"
    ></iframe>
  </div>
</template>

<script>
  export default {
    data: () => ({}),
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/queue.vue